export enum Errors {
    GENERIC = "Une erreur est survenue, veuillez réessayer plus tard.",
    USER_ALREADY_INVITED = "Cet utilisateur a déjà été invité.",
    USER_ALREADY_REGISTERED = "Cet utilisateur est déjà inscrit.",
    WEEK_ALREADY_VALIDATED = "Cette semaine a déjà été validée.",
    NO_SESSIONS_TO_VALIDATE = "Aucune séance de trade ou no-trade n'a été enregistrée pour cette semaine.",
    VALIDATED_WEEK_FILE_REQUIRED = "Veuillez ajouter une image de l'historique du compte.",
    VALIDATED_WEEK_FILE_TYPE_INVALID = "Le fichier doit être une image au format JPG, JPEG ou PNG.",
    VALIDATED_WEEK_UPLOAD_ERROR = "L'envoi de l'image a échoué. Veuillez réessayer.",
    VALIDATED_WEEK_YEAR_REQUIRED = "L'année de la semaine est obligatoire.",
    VALIDATED_WEEK_YEAR_INVALID = "L'année de la semaine est invalide.",
    VALIDATED_WEEK_NUMBER_REQUIRED = "Le numéro de semaine est obligatoire.",
    VALIDATED_WEEK_NUMBER_INVALID = "Le numéro de semaine doit être compris entre 1 et 53.",
    VALIDATED_WEEK_MINDSET_REQUIRED = "Veuillez sélectionner votre état d'esprit.",
    VALIDATED_WEEK_MINDSET_INVALID = "L'état d'esprit sélectionné est invalide.",
    VALIDATED_WEEK_COMMENT_TOO_LONG = "Le commentaire ne peut pas dépasser 2500 caractères.",
    TERMS_NOT_ACCEPTED = "Vous devez accepter les conditions générales pour continuer.",
    TAG_ALREADY_EXISTS = "Ce tag existe déjà.",
    SESSION_DELETE_WINDOW_EXPIRED = "Vous ne pouvez plus supprimer cette session après 48 h",
}